import React from "react";
import { ApartmentOutlined } from "@mui/icons-material";
import {
  Badge,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import EmptyResult from "components/Shared/Lottie/EmptyResult";
import { Link } from "react-router-dom";

const BranchAssignmentMunicipalityTab = ({ municipalityDetail }) => {
  const municipalities =
    municipalityDetail && Array.isArray(municipalityDetail)
      ? municipalityDetail
      : [];

  return (
    <Grid item xs={12}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={3}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge badgeContent={municipalities.length} color="primary">
            <ApartmentOutlined style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Municipalities</Typography>
        </Box>
      </Box>

      <Divider />
      <Box p={2}>
        {municipalities.length > 0 ? (
          <MunicipalityCard municipalities={municipalities} />
        ) : (
          <EmptyResult height={150} />
        )}
      </Box>
    </Grid>
  );
};

export default BranchAssignmentMunicipalityTab;

const MunicipalityCard = ({ municipalities = [] }) => {
  // Filter out any invalid municipalities if necessary
  const validMunicipalities = municipalities.filter(
    (municipality) => municipality?.id && municipality?.label
  );

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {validMunicipalities?.length > 0 ? (
        validMunicipalities.map((municipality) => (
          <div key={municipality?.id} className="group">
            <Link to={`/app/crm/municipality/${municipality?.id}/detail`}>
              <Card
                className="h-full transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
                sx={{
                  borderRadius: 2,
                  "&:hover": {
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                <CardContent sx={{ padding: 2 }}>
                  <div className="flex items-center gap-3">
                    <div className="rounded-full bg-blue-100 p-2 transition-colors group-hover:bg-blue-200">
                      <ApartmentOutlined
                        sx={{
                          fontSize: 20,
                          color: "primary.main",
                        }}
                      />
                    </div>
                    <Typography
                      variant="body2"
                      className="line-clamp-2 font-medium"
                    >
                      {municipality.label}{" "}
                      {/* Display the label of the municipality */}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        ))
      ) : (
        <EmptyResult height={150} />
      )}
    </div>
  );
};
